import React, { useState } from 'react'
import { Plus /*Package, BarChart3*/ } from 'lucide-react'
import ProductCard from '../components/products/ProductCard'
import ProductTable from '../components/products/ProductTable'
import SearchFilters from '../components/forms/SearchFilters'
import Pagination from '../components/common/Pagination'
import ProductModal from '../components/modals/ProductModal'
import DeleteConfirmModal from '../components/modals/DeleteConfirmModal'
import ImageModal from '../components/modals/ImageModal'
import { calculateRemainingStock } from '../utils/calculations'
import './Products.scss'

const Products = ({
  products,
  purchases,
  onProductSave,
  onProductDelete,
  loading,
  nextProductId,
}) => {
  const [productSearch, setProductSearch] = useState('')
  const [stockFilter, setStockFilter] = useState('all')
  // const [productViewMode, setProductViewMode] = useState('table')
  const [currentProductPage, setCurrentProductPage] = useState(1)
  const [showProductModal, setShowProductModal] = useState(false)
  const [editingProduct, setEditingProduct] = useState(null)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(null)
  const [showImageModal, setShowImageModal] = useState(null)

  const itemsPerPage = 5

  // Filtrage des produits
  const allFilteredProducts = products
    .filter((product) => {
      const matchesSearch =
        product.name.toLowerCase().includes(productSearch.toLowerCase()) ||
        product.code.toLowerCase().includes(productSearch.toLowerCase())

      if (!matchesSearch) return false

      if (stockFilter === 'low') {
        const remainingStock = calculateRemainingStock(product, purchases)
        return remainingStock < 2
      }

      return true
    })
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

  // Pagination
  const totalProducts = allFilteredProducts.length
  const startProductIndex = (currentProductPage - 1) * itemsPerPage
  const endProductIndex = startProductIndex + itemsPerPage
  const filteredProducts = allFilteredProducts.slice(
    startProductIndex,
    endProductIndex,
  )

  // Reset page si pas d'éléments sur la page courante
  React.useEffect(() => {
    if (
      totalProducts > 0 &&
      filteredProducts.length === 0 &&
      currentProductPage > 1
    ) {
      setCurrentProductPage(1)
    }
  }, [totalProducts, filteredProducts.length, currentProductPage])

  const handleProductPageChange = (newPage) => {
    setCurrentProductPage(newPage)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handleEditProduct = (product) => {
    setEditingProduct(product)
    setShowProductModal(true)
  }

  const handleDeleteProduct = (product) => {
    setShowDeleteConfirm(product)
  }

  const confirmDeleteProduct = () => {
    if (showDeleteConfirm) {
      onProductDelete(showDeleteConfirm.id)
      setShowDeleteConfirm(null)
    }
  }

  const handleProductSave = (productData, existingProduct) => {
    onProductSave(productData, existingProduct)
    setShowProductModal(false)
    setEditingProduct(null)
  }

  const searchFilters = [
    {
      value: stockFilter,
      onChange: setStockFilter,
      options: [
        { value: 'all', label: 'Tous les produits' },
        { value: 'low', label: 'Stock faible (< 2)' },
      ],
    },
  ]

  return (
    <div className='content-space'>
      <div className='section-header'>
        <h2 className='section-title'>Produits</h2>
        <div className='header-actions'>
          {/* <div className='view-toggle'>
            <button
              onClick={() => setProductViewMode('grid')}
              className={`btn ${
                productViewMode === 'grid' ? 'primary' : 'secondary'
              } sm`}
              title='Vue grille'
            >
              <Package size={16} />
            </button>
            <button
              onClick={() => setProductViewMode('table')}
              className={`btn ${
                productViewMode === 'table' ? 'primary' : 'secondary'
              } sm`}
              title='Vue tableau'
            >
              <BarChart3 size={16} />
            </button>
          </div> */}
          <button
            onClick={() => setShowProductModal(true)}
            className='btn initial'
          >
            <Plus size={15} className='btn-icon' />
            Ajouter un produit
          </button>
        </div>
      </div>

      <SearchFilters
        searchValue={productSearch}
        onSearchChange={setProductSearch}
        filters={searchFilters}
      />

      <div className='table-container'>
        {totalProducts === 0 ? (
          <div className='empty-state'>
            {productSearch || stockFilter !== 'all'
              ? 'Aucun produit trouvé avec ces critères'
              : 'Aucun produit enregistré'}
          </div>
        ) : (
          <>
            {/* {productViewMode === 'grid' && ( */}
            {/* <div className='product-grid'> */}
            <div className='purchase-cards-container'>
              {filteredProducts.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  purchases={purchases}
                  onEdit={handleEditProduct}
                  onDelete={handleDeleteProduct}
                  onImageClick={setShowImageModal}
                />
              ))}
            </div>
            {/* )} */}

            {/* {productViewMode === 'table' && ( */}
            <ProductTable
              products={filteredProducts}
              purchases={purchases}
              onEdit={handleEditProduct}
              onDelete={handleDeleteProduct}
              onImageClick={setShowImageModal}
            />
            {/* )} */}

            <Pagination
              currentPage={currentProductPage}
              totalItems={totalProducts}
              itemsPerPage={itemsPerPage}
              onPageChange={handleProductPageChange}
            />
          </>
        )}
      </div>

      {/* Modales */}
      <ProductModal
        isOpen={showProductModal}
        onClose={() => {
          setShowProductModal(false)
          setEditingProduct(null)
        }}
        product={editingProduct}
        onSave={handleProductSave}
        loading={loading.saving}
        nextProductId={nextProductId}
      />

      <DeleteConfirmModal
        product={showDeleteConfirm}
        isOpen={!!showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(null)}
        onConfirm={confirmDeleteProduct}
        loading={loading.deleting === showDeleteConfirm?.id}
      />

      <ImageModal
        imageUrl={showImageModal}
        isOpen={!!showImageModal}
        onClose={() => setShowImageModal(null)}
      />
    </div>
  )
}

export default Products
